import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 采购履约（采购履约子应用路由）
 */
export default {
  path: 'performance',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '采购履约',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [
    workbenchServiceDict.PURCHASER.value,
    workbenchServiceDict.AGENCY.value,
    workbenchServiceDict.SUPPLIER.value
  ],
  roles: [
    platformFunctionModuleDict.PURCHASER.right,
    platformFunctionModuleDict.AGENCY.right,
    platformFunctionModuleDict.SUPPLIER.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right,
    platformFunctionModuleDict.PROJECT_HANDING.right,
    platformFunctionModuleDict.ENTRUST_HANDING.right,
  ],
  superviseInstitutions: [],

  children: [
    // 验收项目 - 采购人
    {
      path: 'LandlordProject',
      name: 'LandlordProject',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '验收项目（采购人）',
        cache: true,
        isMicro: true,
        icon: 'icon-side_supplier_involved'
      },
      applicableCompanyTypes: [
        {
          companyType: companyTypeDict.ENTERPRISE.value,
          menuName: '验收项目'
        },
        {
          companyType: companyTypeDict.PUBLIC_INSTITUTION.value,
          menuName: '验收项目'
        }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.PURCHASER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 验收项目 - 代理机构
    {
      path: 'AgentProject',
      name: 'AgentProject',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '验收项目（代理机构）',
        cache: true,
        isMicro: true,
        icon: 'icon-side_supplier_involved'
      },
      applicableCompanyTypes: [
        {
          companyType: companyTypeDict.ENTERPRISE.value,
          menuName: '验收项目'
        },
        {
          companyType: companyTypeDict.PUBLIC_INSTITUTION.value,
          menuName: '验收项目'
        }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
      roles: [
        platformFunctionModuleDict.AGENCY.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 验收项目 - 供应商
    {
      path: 'SupplierProject',
      name: 'SupplierProject',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '验收项目（供应商）',
        cache: true,
        isMicro: true,
        icon: 'icon-side_supplier_involved'
      },
      applicableCompanyTypes: [
        {
          companyType: companyTypeDict.ENTERPRISE.value,
          menuName: '验收项目'
        },
        {
          companyType: companyTypeDict.PUBLIC_INSTITUTION.value,
          menuName: '验收项目'
        }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.SUPPLIER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 验收项目审核
    {
      path: 'LandlordProjectCheck',
      name: 'LandlordProjectCheck',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '验收项目审核',
        cache: true,
        isMicro: true,
        icon: 'icon-side_supplier_involved'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right,
        platformFunctionModuleDict.PROJECT_HANDING.right
      ],
      superviseInstitutions: []
    },

    // 委托经办
    {
      path: 'AgentEntrust',
      name: 'AgentEntrust',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '委托经办',
        cache: true,
        isMicro: true,
        icon: 'icon-side_supplier_involved'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
      roles: [
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right,
        platformFunctionModuleDict.ENTRUST_HANDING.right
      ],
      superviseInstitutions: []
    }
  ]
}
